/**
 * Email 格式驗證
 * @description 格式：example@domain.com
 * @description 支援：字母、數字、特殊字符 (. _ % + -)、Gmail 別名功能
 */
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

/**
 * 網域格式驗證
 * @description 格式：subdomain.domain.tld (例如：example.com, sub.example.com)
 */
export const DOMAIN_PATTERN = /^([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/

/**
 * 網址格式驗證
 * @description 支援：http/https 協議、網域、埠號、路徑
 * @description 格式：https://example.com:8080/path
 */
export const URL_PATTERN = /^(https?:\/\/)?([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/

/**
 * 網域首頁最大長度
 */
export const DOMAIN_HOMEPAGE_MAX_LENGTH = 256

/**
 * 移除括號及其內容的正規表達式
 * @description 用於移除文字中的括號部分，例如：「連結 (https://wenk.tw/abc)」→「連結」
 */
export const REMOVE_PARENTHESES_PATTERN = /\s*\(.*?\)\s*/g

/**
 * 短網址原始網址格式驗證
 * @description 支援：http/https/ftp 協議
 * @description 格式：https://example.com/path?query=value
 */
export const SHORT_URL_PATTERN = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i

/**
 * 電話號碼格式驗證（台灣）
 * @description 支援格式：
 * - 手機：09xxxxxxxx, +886-9xxxxxxxx, +886 9xxxxxxxx
 * - 市話：02-xxxxxxxx, (02)xxxxxxxx, +886-2-xxxxxxxx
 */
export const PHONE_NUMBER_PATTERN = /^(\+\d{1,3}-?|0)?9\d{8}$|^(\+\d{1,3}-?|0\d{1,2}-?)?\d{7,8}$/

/**
 * 手機號碼格式驗證（台灣）
 * @description 支援格式：
 * - 手機：09xxxxxxxx, +886-9xxxxxxxx, +886 9xxxxxxxx
 */
export const MOBILE_NUMBER_PATTERN = /^09[0-9]{8}$/

/**
 * Base64 圖片前綴格式
 * @description 用於移除 Base64 圖片的 Data URL 前綴
 * @description 格式：data:image/png;base64, data:image/jpeg;base64, 等
 */
export const BASE64_IMAGE_PREFIX_PATTERN = /^data:image\/[a-zA-Z]+;base64,/

/**
 * 中文字符及全角字符檢測
 * @description 用於判斷字符是否為中文或全角字符（用於計算字符寬度）
 * @description 範圍：\u3400-\u9FBF (中日韓統一表意文字)、\uFF01-\uFF5E (全角字符)
 */
export const CJK_FULLWIDTH_CHAR_PATTERN = /[\u3400-\u9FBF]|[\uFF01-\uFF5E]/

/**
 * 分類標記名稱最大長度
 * @description 中文字符最多7個，對應14個半形字符的寬度
 */
export const ORG_SORT_TAG_NAME_MAX_LENGTH = 7
